import React from 'react';
import { Col } from 'reactstrap';
import { node } from 'prop-types';

const propTypes = {
  children: node.isRequired,
};

const LayoutRightCol = ({ children, ...rest }) => (
  <Col lg="4" {...rest}>
    {children}
  </Col>
);

LayoutRightCol.propTypes = propTypes;
export default LayoutRightCol;
